// extracted by css-extract-rspack-plugin
export default {"AggregateLabels":"repository-group-header-label-module__AggregateLabels__dQI1azG"};